export const IPVALIDATOR = {
    name: 'regexp',
    condition: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
    message:
        'IP Address must be like 123.123.123.123 or 1.2.3.4 each number from 0 to 255',
};
